<script setup>
import {onMounted, ref} from 'vue'
import {
  ElCard,
  ElTableColumn,
  ElSelectOption,
  ElTable,
  ElRow,
  ElCol,
  ElDatePicker,
  ElDialog,
  ElForm,
  ElFormItem,
  ElInput,
  ElMessage,
  ElMessageBox,
  ElOption,
  ElSelect,
  ElButton
} from "element-plus";
import {buyApi, getCityDataApi, searchListApi, syncDeliveryDateApi, syncUsedApi} from "@/service/index.js";
import dayjs from "dayjs";
import {useStore} from "vuex";
import {Delete, Search, TurnOff} from "@element-plus/icons-vue";
import mitts from "@/utils/mitt";
import {onUnmounted} from 'vue'
const store = useStore()
const  stateList=ref([])
const cityList=ref([])
const  stateList2=ref([])
const cityList2=ref([])
let searParams = ref({
  page_size:50,
  page:1,
  online_date:null,
  start_country:null,
  start_province:null,
  start_city:null,
  end_country:null,
  end_province:null,
  end_city:null,
  package_num_type:null,
  delivery_status:null,
  delivery_date:null,
})
let pagination = ref({
  current: 1,
  pageSize: 50,
  total: 100,
  showSizeChanger: false,
})
let payInfo = ref({})
let tabBox = ref(null)
let oBox = ref(null)
let yHeight = ref(0)
let loading = ref(false)
let selectedRowKeys = ref([])
let dialogBuy = ref(false)
let olength=ref(0)
let multipleTableRef=ref(null)

let dialogFilter = ref(false)       // 筛选结果弹窗
let filterList = ref([])            // 筛选后的列表数据
let filterSelected = ref([])        // 弹窗中已勾选的行
let filterTableRef = ref(null)
let filterLoading = ref(false)
// =============================

searParams.value.online_date=dayjs().format('YYYY-MM-DD')
const handleSelectionChange = (e,e2) => {
  console.log(e,e2)
  console.log('multipleTableRef',multipleTableRef.value.getSelectionRows())
  olength.value=multipleTableRef.value.getSelectionRows().length

}
const clearSelection=()=>{
  multipleTableRef.value.clearSelection()
  searParams.value.online_date=dayjs().format('YYYY-MM-DD')
}

const cdata = ref([]);
const getOrderList = (reset=false) => {
  if(reset===true){
    console.log('重置！')
    pagination.value.current=1
  }
  pagination.value.pageSize=searParams.value.page_size-0
  loading.value = true
  // searParams.value.online_date=dayjs().format('YYYY-MM-DD')
  searchListApi({...searParams.value, page: pagination.value.current}).then(res => {
    if (res.data.code == 1) {
      cdata.value = res.data.data.data
      pagination.value.total = res.data.data.total
    } else {
      ElMessage({
        message: res.data.msg,
        type: 'warning',
      })
    }
    console.log('data', cdata.value)
  }).finally(() => {
    loading.value = false
  })
}
onMounted(() => {
})
const pageChange = (p) => {
  pagination.value.current = p
  getOrderList()
}
const ok1 = (v) => {
  // searParams.value.begin_time = v.$d
}
const ok2 = (v) => {
  // searParams.value.end_time= v.$d
}
const reset = () => {
  searParams.value = {
    page_size:50,
    page:1,
    online_date:dayjs().format('YYYY-MM-DD'),
    start_country:null,
    start_province:null,
    start_city:null,
    end_country:null,
    end_province:null,
    end_city:null,
    package_num_type:null,
    delivery_status:null,
    delivery_date:null,
  }
  pagination.value = {
    current: 1,
    pageSize: 50,
    total: 100
  }
  getOrderList()

}
const buy = (scope) => {
  console.log('scope',scope)
  loading.value = true
  if(scope){
    buyApi({ids: scope.row.id}).then(res => {
      if (res.data.code == 1) {
        selectedRowKeys.value = []
        payInfo.value = res.data.data
        dialogBuy.value = true
        payInfo.value.waybill_sn=payInfo.value.waybill_sn.join('<br>')
        console.log('payInfo.value.waybill_sn',payInfo.value.waybill_sn)
        getOrderList()
      } else {
        ElMessage({
          message: res.data.msg,
          type: 'warning',
        })
      }
    }).finally(() => {
      store.dispatch('updateUserInfoStatus')
      loading.value = false
    })
    return
  }
  console.log('selectedRowKeys', multipleTableRef.value.getSelectionRows())
  let ids=multipleTableRef.value.getSelectionRows().map(item=>item.id).join(',')
  console.log('ids',ids)
  if(ids.length<=1){
    ElMessage({
      message: '请勾选单号',
      type: 'error',
    })
    loading.value = false
    return;
  }
  buyApi({ids: ids}).then(res => {
    if (res.data.code == 1) {
      selectedRowKeys.value = []
      payInfo.value = res.data.data
      payInfo.value.waybill_sn=payInfo.value.waybill_sn.join('<br>')
      console.log('payInfo.value.waybill_sn',payInfo.value.waybill_sn)
      dialogBuy.value = true
      getOrderList()
    } else {
      ElMessage({
        message: res.data.msg,
        type: 'warning',
      })
    }
  }).finally(() => {
    store.dispatch('updateUserInfoStatus')
    loading.value = false
  })
}
const update=(scope)=>{
  // $index
  syncDeliveryDateApi({id:scope.row.id}).then(res=>{
    if(res.data.code==1){
      cdata.value[scope.$index]=res.data.data
      ElMessage({
        message: "更新成功",
        type: 'success',
      })
    }else {
      ElMessage({
        message: res.data.msg,
        type: 'warning',
      })
    }
  })
}

const filterHandleSelectionChange = (rows) => {
  filterSelected.value = rows || []
}

const filterClearSelection = () => {
  if (filterTableRef.value) filterTableRef.value.clearSelection()
  filterSelected.value = []
}

const filterBatchBuy = () => {
  if (!filterSelected.value || filterSelected.value.length === 0) {
    ElMessage({ message: '请勾选单号', type: 'error' })
    return
  }
  const ids = filterSelected.value.map(item => item.id).join(',')
  filterLoading.value = true
  buyApi({ ids }).then(res => {
    if (res.data.code == 1) {
      payInfo.value = res.data.data
      payInfo.value.waybill_sn = payInfo.value.waybill_sn.join('<br>')
      dialogBuy.value = true
      // 把已兑换的从筛选列表里隐藏，只保留未兑换的
      const boughtIds = new Set(filterSelected.value.map(i => i.id))
      filterList.value = filterList.value.filter(i => !boughtIds.has(i.id))
      filterSelected.value = []
      if (filterTableRef.value) filterTableRef.value.clearSelection()
      // 同步刷新主列表
      getOrderList()
    } else {
      ElMessage({ message: res.data.msg, type: 'warning' })
    }
  }).finally(() => {
    store.dispatch('updateUserInfoStatus')
    filterLoading.value = false
  })
}
// =================================================

const copyToClipboard = () => {
  let text = payInfo.value.waybill_sn.replaceAll('<br>','\n')
  var textarea = document.createElement('textarea');
  textarea.style.position = 'fixed';
  textarea.style.opacity = 0;
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
  ElMessage({
    message: "复制成功",
    type: 'success',
  })
  dialogBuy.value = false
}

const cityChange = (val,level,type) => {
  let params = {
    level:level,
  keyword:val,
  }
  getCityDataApi(params).then(res=>{
  if(res.data.code==1){
    console.log('看看国家',res)
    // 发货
    if(level==2&&type==1){
      stateList.value=res.data.data
      searParams.value.start_province=null
      searParams.value.start_city=null
    }
    if(level==3&&type==1){
      cityList.value=res.data.data
      searParams.value.start_city=null
    }
    // 收货
    if(level==2&&type==2){
      stateList2.value=res.data.data
      searParams.value.end_province=null
      searParams.value.end_city=null
    }
    if(level==3&&type==2){
      cityList2.value=res.data.data
      searParams.value.end_city=null
    }
  }
  })
}
const clear = (level,type) => {
  if(level==2&&type==1){
    searParams.value.start_province=null
    searParams.value.start_city=null
  }
  if(level==3&&type==1){
    searParams.value.start_city=null
  }
  if(level==2&&type==2){
    searParams.value.end_province=null
    searParams.value.end_city=null
  }
  if(level==3&&type==2){
    searParams.value.end_city=null
  }
  console.log('levelType',level,type)
}
getOrderList()
mitts.on('handleChange',getOrderList)
onUnmounted(()=>{
  mitts.off('handleChange',getOrderList)
})
</script>

<template>

  <div class="o-list-box" ref="oBox">
    <el-row :gutter="20">
      <el-form :model="searParams" label-width="100px" class="search-box">
        <el-col :span="6">
          <div>
            <el-form-item label="发货地国家" prop="start_country">
              <el-select
                  show-search
                  placeholder="请选择发货地国家"
                  allow-clear
                  clearable
                  filterable
                  @clear="clear(2,1)"
                  style="height: 40px"
                  v-model="searParams.start_country"
                  @change="(v)=>cityChange(v,2,1)"
              >
                <el-option v-for="(item,index) in  store.state.clist" :label="item" :value="item.split('--').pop()">
                  <p style="margin: 0;padding: 0;display: flex;justify-content: space-between" ><span>{{ item.split('--')[0] }}</span><span style="color: #8e9aae" >{{ item.split('--')[1] }}</span></p>
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-form-item label="发货地州" prop="start_province">
              <el-select
                  show-search
                  placeholder="请选择发货地州"
                  allow-clear
                  filterable
                  clearable
                  @clear="clear(3,1)"
                  @change="(v)=>cityChange(v,3,1)"
                  style="height: 40px"
                  v-model="searParams.start_province"
              >
                <el-option v-for="(item,index) in  stateList" :label="item" :value="item">{{
                    item
                  }}
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-form-item label="发货地城市" prop="start_city">
              <el-select
                  show-search
                  placeholder="请选择发货地城市"
                  allow-clear
                  filterable
                  style="height: 40px"
                  v-model="searParams.start_city"
              >
                <el-option v-for="(item,index) in  cityList" :label="item" :value="item">{{
                    item
                  }}
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <el-form-item label="上网日期" prop="online_date"  >
            <el-date-picker :clearable="false" type="date" style="height: 40px;width: 250px" format="YYYY-MM-DD" value-format="YYYY-MM-DD" show-time placeholder="请选择上网日期" v-model="searParams.online_date" @ok="ok1"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收货地国家" prop="end_country">
              <el-select
                  show-search
                  placeholder="请选择收货地国家"
                  allow-clear
                  filterable
                  clearable
                  @clear="clear(2,2)"
                  style="height: 40px"
                  v-model="searParams.end_country"
                  @change="(v)=>cityChange(v,2,2)"
              >
                <el-option v-for="(item,index) in  store.state.clist" :label="item" :value="item.split('--').pop()">
                  <p style="margin: 0;padding: 0;display: flex;justify-content: space-between" ><span>{{ item.split('--')[0] }}</span><span style="color: #8e9aae" >{{ item.split('--')[1] }}</span></p>
                </el-option>
              </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收货地州" prop="end_province">
            <el-select
                show-search
                placeholder="请选择收货地州"
                allow-clear
                filterable
                clearable
                @clear="clear(3,2)"
                style="height: 40px"
                v-model="searParams.end_province"
                @change="(v)=>cityChange(v,3,2)"
            >
              <el-option v-for="(item,index) in  stateList2" :label="item" :value="item">
                <p style="margin: 0;padding: 0;display: flex;justify-content: space-between" ><span>{{ item}}</span></p>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收货地城市" prop="end_city">
            <el-select
                show-search
                placeholder="请选择收货地城市"
                allow-clear
                filterable
                
                style="height: 40px"
                v-model="searParams.end_city"
            >
              <el-option v-for="(item,index) in  cityList2" :label="item" :value="item">
                <p style="margin: 0;padding: 0;display: flex;justify-content: space-between" ><span>{{ item}}</span></p>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="预计送达日期" prop="delivery_date">
            <el-date-picker clearable type="date" style="height: 40px;width: 250px" format="YYYY-MM-DD" value-format="YYYY-MM-DD" placeholder="请选择预计送达日期" v-model="searParams.delivery_date"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <div>
            <el-form-item prop="delivery_status" label="单号状态">
              <el-select
                  style="height: 40px;width: 270px"
                  ref="select"
                  show-search
                  allow-clear
                  placeholder="无限制"
                  v-model="searParams.delivery_status"
              >
                <el-option
                    v-for="(item,index) in  ['无限制', '运输中', '已上网']"
                    :key="index"
                    :label="item"
                    :value="index"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="6">
          <div  >
            <el-form-item prop="package_num" label="包裹数量">
              <el-select
                  style="height: 40px;width: 280px"
                  ref="select"
                  show-search
                  allow-clear
                  placeholder="请选择包裹数量"
                  v-model="searParams.package_num_type"
              >
                <el-option
                    v-for="(item,index) in  ['无限制', '=1', '2~5', '6~10', '>10']"
                    :key="index"
                    :label="item"
                    :value="index"
                />
              </el-select>
            </el-form-item>
          </div>
        </el-col>

        <el-col :span="6">
          <el-form-item label="每页显示数量" class="search-item-box" prop="end_country">
            <el-input style="height: 40px;width: 290px;" v-model.number="searParams.page_size" type="number"></el-input>
          </el-form-item>
        </el-col>

        <div class="b" style="width: 100%;">

          <div class="ba" style="width: 100%;">
            <span style="color: orange">（左侧这里可以勾选多个后，右侧点击批量兑换）</span>
          </div>

          <el-button :icon="Delete" @click="clearSelection" type="warning" size="large" round>一键清空</el-button>
          <el-button :icon="TurnOff" @click="buy(null)" type="success" round size="large">批量兑换{{olength>0?`(${olength}个)`:''}}</el-button>
          <el-button :icon="TurnOff" @click="reset" type="info" round size="large">重置</el-button>
          <el-button :icon="Search" @click="getOrderList" :loading="loading" type="primary" round size="large">搜索
          </el-button>
        </div>
      </el-form>
    </el-row>
    <el-affix :offset="0" direction="horizontal">
    <div class="tab-box" ref="tabBox">
      <el-table
          border
          ref="multipleTableRef"
          height="85.5vh"
          v-loading="loading"
          :data="cdata"
          style="width: 100%"
          current-row-key="id"
          @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"/>
        <el-table-column label="快递单号" prop="waybill_sn" width="84"></el-table-column>
        <el-table-column property="start_address" label="发货地" />
        <el-table-column property="end_address" label="收货地" />

        <el-table-column  label="单号类型" width="90" align="center">
          <template #default="scope">
            <span>{{scope.row.types}}</span>
          </template>
        </el-table-column>
<!--        <el-table-column property="delivery_date" label="预计送达日期" width="100" align="center"/>-->
        <el-table-column property="types" label="单号状态" width="90" align="center">
          <template #default="{row}">
                      <el-button type="warning" v-if="!row.delivery_date" size="small" delivery_date >已上网</el-button>
                      <el-button type="success" v-if="row.delivery_date"  size="small" >运输中</el-button>
          </template>
        </el-table-column>
        <el-table-column  label="所需兑换币" width="90" align="center">
          <span>1</span>
        </el-table-column>
<!--        <el-table-column property="st" label="适用平台" width="170" tooltip-effect >-->
<!--          <el-button type="primary" size="small" >敦煌网,速卖通,亚马逊,eBay,独立站等跨境平台</el-button>-->
<!--        </el-table-column>-->
        <el-table-column property="online_str" label="上网时间" width="140"/>
        <el-table-column property="delivery_date" label="预计送达日期" width="100"/>
        <el-table-column property="package_num" align="center" label="包裹数量" width="80"/>
        <el-table-column property="st" label="操作"  align="center" width="130" fixed="right" >
          <template #default="scope">
            <div class="bx" style="display: flex;" >
              <el-button size="small"  type="primary" @click="buy(scope)" :loading="loading">兑换</el-button>
            <el-button size="small" type="success"  v-if="scope.row.sync_status==1||scope.row.sync_status==2" :disabled="scope.row.sync_status==2"  @click="update(scope)" :loading="loading">更新</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="p-box" style="width: 100%;height:7vh;display: flex;justify-content: center;align-items: center" >
      <el-pagination
          style="margin: 0 auto"
          :current-page="pagination.current"
          layout="prev, pager, next"
          :total="pagination.total"
          :page-size="pagination.pageSize"
          @currentChange="pageChange"
      />
      </div>
    </div>
    </el-affix>
    <el-dialog
        v-model="dialogBuy"
        width="500"
        :show-close="false"
    >
      <template #default>
        <div class="icc-box" v-if="payInfo&&payInfo.waybill_sn">
          <img src="@/assets/success.png" class="icc" alt="">
          <h1>兑换成功!</h1>
          <p class="d">订单号：{{ payInfo.log.order_sn }}</p>
          <a-divider style="border-color: rgba(0,0,0,0.09)" dashed/>
          <div class="l-box">
            <div class="l">兑换日期</div>
            <div class="l">兑换数量</div>
          </div>
          <div class="l-box">
            <div class="n">{{ dayjs(payInfo.log.createtime * 1000).format('YYYY-MM-DD HH:mm:ss') }}</div>
            <div class="n">{{ payInfo.log.score }}</div>
          </div>
          <div style="width: 5px;height: 30px"></div>

          <div class="l-box">
            <div class="l">兑换状态</div>
            <div class="l">消耗兑换币</div>
          </div>
          <div class="l-box">
            <div class="n">
              <a-tag color="green" style="transform: scale(1.2)">成功</a-tag>
            </div>
            <div class="n">
              <a-tag color="green" style="transform: scale(1.2)">{{ payInfo.log.score }}</a-tag>
            </div>
          </div>
          <a-divider style="border-color: rgba(0,0,0,0.09)" dashed/>
          <h1>单号列表</h1>
          <div v-html="payInfo.waybill_sn" style="padding: 10px;width: 440px;height: 115px;border-radius: 5px;box-sizing:border-box;overflow-x: hidden;overflow-y: scroll;border:1px solid #dcdfe6 " >

          </div>
          <el-button type="primary" style="width: 80%;height:40px;transform: translateY(50px)" @click="copyToClipboard">
            复制单号
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>

</template>

<style lang="less" scoped>
.o-list-box {
  display: flex;
  //height: 100%;
  flex: 1;
  flex-direction: column;
}

.tab-box::-webkit-scrollbar {
  width: 0px;
  overflow-y: hidden;
}

.tab-box {
  width: 100%;
  flex: 1;
//overflow-y: scroll;
}

.search-box {
  display: flex;
  flex-wrap: wrap;

  .search-item-box {
    //margin-right: 20px;
    display: flex;
    align-items: center;

    span {
      margin-right: 10px;
    }
  }
}

.b {
  display: flex;
  justify-content: flex-end;
  padding: 5px;
  margin-bottom: 10px;

  .ba {
    display: flex;
    justify-content: flex-begin;
    padding: 5px;
    margin-bottom: 10px;
  }
}

.icc-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateY(-80px);

  .icc {
    width: 100px;
    background: white;
    border-radius: 50%;
  }
}

.l-box {
  display: flex;
  justify-content: space-between;
  width: 90%;

  .l {
    color: rgba(0, 0, 0, 0.5);
  }

  .n {
    color: black;
    font-size: 18px;
    margin-top: 8px;
  }
}
/deep/.el-select__wrapper{
  min-height: 40px !important;
}
/deep/thead{
  color: rgb(61, 118, 206) !important;


}
/deep/th{
  background: rgb(235, 243, 255) !important;
}

/deep/ .number:nth-last-child(1){
  //background: rebeccapurple !important;
  display: none;
}
</style>
